import React, { useState } from 'react';
import { Card } from 'components/shadcn/ui/card';
import { useNavigate } from 'react-router-dom';
import HGSuccessCard from 'components/HGSuccessCard';
import AddDeviceForm from './AddDeviceForm';

const AddDevice = () => {
    const navigate = useNavigate();
    const [newDevice, setNewDevice] = useState(null);
    const [success, setSuccess] = useState(false);

    if (success) {
        const newDeviceType = newDevice?.ThingType?.includes('NEP')
            ? 'gateway'
            : 'battery system';
        const addMicrosButton = {
            onClick: () => {
                setSuccess(false);
                navigate(`/devices/${newDevice?.Thing_ID}/add-microinverters`);
            },
            buttonText: `add microinverters`,
        };
        const buttons = [
            {
                onClick: () => navigate(`/devices/${newDevice?.Thing_ID}`),
                buttonText: `go to ${newDeviceType} profile`,
            },
        ];
        if (newDeviceType === 'gateway') buttons.unshift(addMicrosButton);
        return (
            <HGSuccessCard buttons={buttons}>
                The {newDevice?.ThingType} has been added successfully!
                <br />
                {newDeviceType === 'gateway' &&
                    'Would You Like to add microinverters?'}
            </HGSuccessCard>
        );
    }

    return (
        <Card>
            <div className="p-3">
                <h4 className="mb-5">Device Info</h4>
                <AddDeviceForm
                    setSuccess={setSuccess}
                    setNewDevice={setNewDevice}
                />
            </div>
        </Card>
    );
};

export default AddDevice;
